import React, { useEffect } from "react";
import { useAuth } from "../../contexts/OAuthContext";
import AppLoading from "../shared/loading/AppLoading";

const SNCLogin = () => {
    const {
        login,
    } = useAuth();

    useEffect(() => {
        login();
    }, []);


    return (
        <div className="position-center">
            <AppLoading/>
            {/*<div className="kt-error-v1__container">*/}
            {/*    <p className="kt-error-v1__desc">*/}
            {/*        /!*<Trans i18nKey="common.message.error.something-went-wrong-here"></Trans>*!/*/}
            {/*    </p>*/}
            {/*</div>*/}
        </div>
    );
}

export default SNCLogin;
